import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, ArrowLeft } from "lucide-react";
import { rePost, dl } from "@/lib/docstate";

const fmtDate = (s) => { try { return new Date(s).toLocaleDateString("en-GB", { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; } };

export default function DocstatePost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [missing, setMissing] = useState(false);

  useEffect(() => { window.scrollTo(0, 0); setPost(null); setMissing(false); rePost(slug).then(setPost).catch(() => setMissing(true)); }, [slug]);

  if (missing) return <div className="ds-bg flex min-h-screen flex-col items-center justify-center gap-4 pt-16"><p className="ds-display text-xl text-[#F3E5AB]">Article not found</p><Link to={dl("/blog")} className="ds-outline-btn px-5 py-2.5 text-sm">Back to Journal</Link></div>;
  if (!post) return <div className="ds-bg flex min-h-screen items-center justify-center pt-16"><Loader2 className="h-8 w-8 animate-spin text-[#C9A24B]" /></div>;

  return (
    <div className="ds-bg min-h-screen pt-16" data-testid="docstate-post">
      <section className="relative flex min-h-[50vh] items-end overflow-hidden">
        <img src={post.cover} alt={post.title} className="absolute inset-0 h-full w-full object-cover opacity-45" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0B0B0C] via-[#0B0B0C]/70 to-transparent" />
        <div className="relative mx-auto w-full max-w-3xl px-4 pb-10 sm:px-8">
          {post.category && <p className="ds-eyebrow">{post.category}</p>}
          <h1 className="ds-display mt-2 text-3xl font-medium text-white sm:text-4xl">{post.title}</h1>
          <p className="mt-3 text-sm text-[#9D8D83]">{post.author ? `${post.author} · ` : ""}{fmtDate(post.created_at)}</p>
        </div>
      </section>

      <article className="mx-auto max-w-3xl px-4 py-12 sm:px-8">
        <Link to={dl("/blog")} className="mb-8 inline-flex items-center gap-2 text-sm text-[#9D8D83] transition-colors hover:text-[#F3E5AB]"><ArrowLeft className="h-4 w-4" /> Back to Journal</Link>
        <div className="space-y-5 text-[17px] font-light leading-relaxed text-[#C9BBB2]">
          {String(post.body || "").split("\n").filter((l) => l.trim()).map((para, i) => <p key={i}>{para}</p>)}
        </div>
        {Array.isArray(post.tags) && post.tags.length > 0 && (
          <div className="mt-8 flex flex-wrap gap-2">
            {post.tags.map((t) => <span key={t} className="rounded-full border border-[#C9A24B]/25 px-3 py-1 text-xs text-[#9D8D83]">#{t}</span>)}
          </div>
        )}
      </article>

      {Array.isArray(post.related) && post.related.length > 0 && (
        <div className="mx-auto max-w-5xl px-4 pb-16 sm:px-8">
          <h2 className="ds-display text-2xl text-white">More from the Journal</h2>
          <div className="mt-6 grid gap-6 sm:grid-cols-3">
            {post.related.map((r) => (
              <Link key={r.id} to={dl(`/blog/${r.slug}`)} className="ds-card group overflow-hidden">
                <img src={r.cover} alt={r.title} className="h-36 w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                <p className="ds-display p-4 text-sm text-white group-hover:text-[#F3E5AB]">{r.title}</p>
              </Link>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
